<script setup>
import AlertPopup from '../AlertPopup.vue';
</script>

<template>
  <div class="h-full bg-gray-900">
    <alert-popup />
    <slot />
  </div>
</template>
